export const MAX_DISPLAY_COUNT = 11;
export const PAGE_SIZE = 10;
export const FEATURED_THREADS_PAGE_SIZE = 10;
export const CATEGORY_GROUPS_SIDEBAR_NUMBER = 12;
export const CATEGORY_GROUPS_NUMBER = 20;
export const EXPLORE_TOTAL_PAGES = 4;
export const CATEGORY_SIDE_BAR_SIZE = 6;
export const COMMUNITY_GUIDLINES = '/page/mc-community-guidelines';
export const CONTENT_CHARACTER_LIMIT = 500;
export const DEFAULT_NAME = 'Community User';
export const ANALYTICS_LOGIN_MESSAGE =
  'Sign in or Register to join the conversation';
export const ANALYTICS_LOGIN_LINK_TEXT = 'Sign in or Register';
export const DEFAULT_CATEGORY_ID = '22';
export const SEEKMAX_APP_LINK_MY = 'https://i85sf.app.link/careerhub_app_my';
export const SEEKMAX_APP_LINK_PH = 'https://i85sf.app.link/careerhub_app_ph';
export const SEEKMAX_APP_LINK_ID_EN = 'https://i85sf.app.link/careerhub_app_id';
export const SEEKMAX_APP_LINK_ID_ID = 'https://i85sf.app.link/karirku_app_id';
export const SEEKMAX_APP_LINK_SG = 'https://i85sf.app.link/careerhub_app_sg';
export const DESKTOP_WIDTH = 1280;
export const DESKTOP_HEIGHT = 800;
export const MOBILE_WIDTH = 390;
export const MOBILE_HEIGHT = 844;
export const APP_PLATFORMS = [
  {
    link: ' https://apps.apple.com/my/app/jobstreet-job-career-search/id367294492',
    platform: 'apple',
  },
  {
    link: 'https://play.google.com/store/apps/details?id=com.jobstreet.jobstreet&hl=en ',
    platform: 'android',
  },
];
